<app-print-office-header></app-print-office-header>

<ion-content [fullscreen]="true">
  <app-print-office-stats></app-print-office-stats>
</ion-content>
